const users = {
  pageName: 'משתמשים',
  mainTabs: {
    titleInvitations: 'הזמנות',
    titleExistingUsers: 'משתמשים קיימים',
  },
  headerButtons: {
    invite: {
      inviteBtn: 'הזמן',
    },
  },
  toast: {
    error: {
      default: 'אירעה שגיאה לא ידועה.',
      badResponse: 'תגובת שרת שגויה עבור משתמש',
      create: {},
      edit: {
        change: 'סיסמה ישנה שגויה',
      },
      unauthorized: 'הפעולה אינה מורשית.',
    },
    success: {
      delete: {
        default: 'המשתמש נמחק בהצלחה',
      },
      create: {
        default: 'המשתמש נוצר בהצלחה.',
      },
      edit: {
        change: 'הסיסמה שונתה',
        default: 'המשתמש עודכן.',
      },
      reset: {
        default: 'דוא"ל לאיפוס סיסמה נשלח בהצלחה.',
      },
    },
  },

  deleteModal: {
    header: 'מחק משתמשים',
    body: 'אתה עומד למחוק {{num}} משתמשים.',
  },

  create: {
    alreadyExistToast: {
      message: 'אירעה שגיאה. האימייל כבר קיים. אנא נסה אימייל אחר.',
    },
    errorRequestToast: {
      message: 'אסור. אין לך הרשאות לבצע פעולה זו. אנא פנה למנהל.',
    },
    successToast: {
      message: 'הצלחה! המשתמש נוצר בהצלחה',
    },
    validations: {
      firstName: 'שם פרטי נדרש',
      lastName: 'שם משפחה נדרש',
      phone: {
        invalid: 'מספר טלפון אינו חוקי',
        required: 'טלפון נדרש',
        length: 'מספר הטלפון צריך להכיל בין 6 ל-16 ספרות',
      },
      email: {
        required: 'אימייל נדרש',
        email: 'כתובת אימייל לא חוקית',
      },
      role: {
        required: 'תפקיד נדרש',
      },
      supplier: {
        required: 'ספק נדרש',
      },
    },
  },
  select: 'בחר',
  edit: {
    modalRemoveConfirm: {
      header: 'אזהרה!',
      body: 'האם אתה בטוח שברצונך למחוק משתמש זה? הערה: אם משויך לאתרים אחרים המשתמש יוסר רק מהאתר הנוכחי.',
      modalRemoveConfirmBtn: 'מחק',
    },
    formTabs: {
      informationTab: 'מידע',
      notesTab: 'הערות',
      historyTab: 'היסטוריה',
    },
  },

  table: {
    filters: {
      role: 'תפקיד',
    },
    headers: {
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
      role: 'תפקיד',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },
  isCompanyAdmin: 'מנהל חברה',

  form: {
    header: {
      createUser: {
        title: 'הוסף',
      },

      updateUser: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    selectOption: {
      select: 'בחר',
    },
    information: {
      details: {
        header: 'פרטים אישיים',
        fields: {
          firstName: 'שם פרטי',
          lastName: 'שם משפחה',
          name: 'שם',
          phone: 'טלפון',
          email: 'אימייל',
          site: 'אתר',
        },
      },
      roles: {
        header: 'אתרים ותפקידים',
        fields: {
          role: 'תפקיד',
          site: 'אתר',
        },
        buttons: {
          addAccess: 'הוסף אתר',
        },
      },
      actions: {
        header: 'פעולות',
        buttons: {
          delete: 'מחק',
          resetPassword: 'איפוס סיסמה',
          changePassword: 'שנה סיסמה',
        },
      },
    },
    valdations: {
      firstName: 'שם פרטי נדרש',
      lastName: 'שם משפחה נדרש',
      phone: 'טלפון נדרש',
      supplier: 'ספק נדרש',
      role: 'תפקיד נדרש',
      email: {
        required: 'אימייל נדרש',
        email: 'כתובת אימייל לא חוקית',
      },
    },
  },
};

export default users;
